export enum DownloadDocumentFileType {
  PDF = 'pdf',
  XML = 'xml',
}
